import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './issue-user-account-shop-coupon-list_types.2';

export function issueUserAccountShopCouponList(variable: types.IssueUserAccountShopCouponListVariables, options?: GqlRequestOptions) {
  const query = 'mutation IssueUserAccountShopCouponList($input: IssueUserAccountShopCouponListInput!) { issueUserAccountShopCouponList(input: $input) { shop_id_list coupon_list { user_account_coupon_policy { id } } } }';
  return gql_request<types.IssueUserAccountShopCouponList, types.IssueUserAccountShopCouponListVariables>('IssueUserAccountShopCouponList', query, variable, { use_consumer: true, ...options });
}

